/**
 * Scriptures for lesson high-priest-1 (keys). D&C 20:60 aligned with scriptures.training.core3.
 */
import type { Scripture } from './scriptures';

export const highPriest1TrainingScripturesEn: Scripture[] = [
  {
    id: 'dc-20-60',
    reference: 'Doctrine and Covenants 20:60',
    text:
      'Every elder, priest, teacher, or deacon is to be ordained according to the gifts and callings of God unto him; and he is to be ordained by the power of the Holy Ghost, which is in the one who ordains him.',
    verses: [
      {
        verse: 60,
        text: 'Every elder, priest, teacher, or deacon is to be ordained according to the gifts and callings of God unto him; and he is to be ordained by the power of the Holy Ghost, which is in the one who ordains him.',
      },
    ],
    context: 'Priesthood ordination is by the power of the Holy Ghost in him who ordains.',
  },
];
